const LAST_CONTACT_SOURCE_LABELS = {
    app: "app",
    hubspot: "HubSpot",
    gmail: "Gmail",
    instantly: "Instantly",
};
/** Follow-up days are Budapest days, wherever the page is opened */
export const formatFollowupDate = (date) => new Date(date).toLocaleDateString("en-GB", { day: "numeric", month: "short", timeZone: "Europe/Budapest" });
/** "6 Oct (Gmail)", or "Never contacted" */
export const describeLastContact = (lastContactAt, source) => lastContactAt
    ? `${formatFollowupDate(lastContactAt)}${source ? ` (${LAST_CONTACT_SOURCE_LABELS[source]})` : ""}`
    : "Never contacted";
/** The automation names deals email + Last + First, e.g. "nick@hopejobs.comHopeNick"; returns "Nick Hope" */
const nameFromDealName = (dealName, email) => {
    if (!(email && dealName.toLowerCase().startsWith(email.toLowerCase())))
        return "";
    const rest = dealName.slice(email.length);
    const parts = rest.match(/\p{Lu}[^\p{Lu}]*/gu) || [];
    // Only "LastFirst" splits unambiguously; names like "McDonald" would split in the wrong place
    return parts.length === 2 && parts.join("") === rest ? `${parts[1].trim()} ${parts[0].trim()}` : "";
};
/**
 * "First Last · email", falling back to the HubSpot deal name when neither the name nor the email is known. HubSpot's
 * contact lookup returns no last name, so a one-word contact name gives way to the full name in the deal name.
 */
export const formatLeadHeading = (dealName, contactName, email) => {
    const contactFullName = contactName.trim();
    const isFullName = contactFullName.split(/\s+/).length > 1;
    const name = (isFullName ? contactFullName : nameFromDealName(dealName, email)) || contactFullName;
    if (name && email)
        return `${name} · ${email}`;
    return name || email || dealName;
};
